import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1l": "#E4B670",
    "col1n": "#D19532"
}
function SkiWou019({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M19.6 9.8q0-4.1-2.9-6.9Q13.9 0 9.75 0 6.8 0 4.5 1.5q-.9.6-1.7 1.4-.85.85-1.45 1.85Q0 6.95 0 9.8q0 2.8 1.35 5.1.6.95 1.45 1.85.8.8 1.7 1.4 2.3 1.5 5.25 1.5 4.15 0 6.95-2.9 2.9-2.9 2.9-6.95z"
                    id="SkiWou019__Symbol_39_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M19.95 10q0-4.2-2.95-7.05Q14.15 0 9.95 0q-3 0-5.35 1.55-.9.6-1.7 1.4-.9.85-1.5 1.9Q0 7.1 0 10q0 2.85 1.4 5.15.6 1 1.5 1.9.8.8 1.7 1.4Q6.95 20 9.95 20q4.2 0 7.05-2.95 2.95-2.95 2.95-7.05m-4.6 5.3H4.55V4.7h10.8v10.6z"
                    id="SkiWou019__Symbol_38_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiWou019__Symbol_39_0_Layer0_0_FILL"
                transform="translate(213.45 220.65)"
                id="SkiWou019__col1n"
            />
            <use
                xlinkHref="#SkiWou019__Symbol_38_0_Layer0_0_FILL"
                transform="translate(213.2 220.45)"
                id="SkiWou019__col1l"
            />
        </g></g>
    )
}
export default SkiWou019
